// extracted by mini-css-extract-plugin
export default {"wrapper":"Du-z","viewport":"Eu-z","container":"Fu-z","slide":"Gu-z"};